<h2 [sxc-toolbar]="toolbarHelperSvc.toolbarMain(categoryInfo().EntityId)">Legacy Software</h2>

@if (title() === downloadCategory.LegacyDriver && items().length > 0) {
  <p>The drivers provided below are no longer actively maintained and will not be updated. To benefit from the latest features and bug fixes, please use a more recent release.</p>
}

@if (items().length > 0) {
  <span [innerHTML]="categoryInfo().NotesBefore"></span>
  @for (legacyDriverGroup of sortedItems(); track legacyDriverGroup.Title) {
    <mat-accordion>
      <mat-expansion-panel style="margin-bottom: 8px">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ legacyDriverGroup.Title }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <table class="table table-hover table-striped">
          <tbody>
            @for (legacyDriver of legacyDriverGroup.Driver; track legacyDriver.Id) {
              <tr>
                <td [sxc-toolbar]="toolbarHelperSvc.toolbarEditDownload(legacyDriver.Id, legacyDriver.Title, legacyDriver.EntityGuid)">
                  <a [href]="legacyDriver.DownloadUrl" target="{{ legacyDriver.Target }}">
                    {{ legacyDriver.Title }}
                  </a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </mat-expansion-panel>
    </mat-accordion>
  }

  <span [innerHTML]="categoryInfo().NotesAfter"></span>
}

@if (items().length === 0) {
  <p>No Downloads</p>
}
